import React from 'react';
import PersonTeaser from './Teaser';
import PersonCard from './Card';

const Person = (props) => {
  const { viewMode } = props;

  switch (viewMode) {
    case 'card':
      return <PersonCard {...props} />;

    default:
      return <PersonTeaser {...props} />;
  }
};

export default Person;
